<template>

<div class="main social-media list-view">
	<div class="left-sidebarz filters">
		<div class="title">Enter your link for each social media platform you want to add to your website...</div>
		<button class="button primary" @click="save()">Save Social Media</button>
	</div>
	<div class="detail no-sub-header" v-if="!loading">
		<div class="social-media-settings">
			<label><i class="fab fa-facebook-square"></i> Facebook</label>
			<input v-model="socialMediaPreferences.FACEBOOK" type="text">
			<div class="message facebook">
				<message :message="(facebookMessage == 'loading') ? null : facebookMessage" @transitionDone="facebookMessage = null" class="loading"></message>
				<i class="fas fa-spinner fa-spin" v-if="facebookMessage == 'loading'"></i>
			</div>

			<label><i class="fab fa-x-twitter"></i> X</label>
			<input v-model="socialMediaPreferences.TWITTER" type="text">
			<div class="message twitter">
				<message :message="(twitterMessage == 'loading') ? null : twitterMessage" @transitionDone="twitterMessage = null" class="loading"></message>
				<i class="fas fa-spinner fa-spin" v-if="twitterMessage == 'loading'"></i>
			</div>

			<label><i class="fab fa-pinterest-square"></i> Pinterest</label>
			<input v-model="socialMediaPreferences.PINTREST" type="text">
			<div class="message pinterest">
				<message :message="(pintrestMessage == 'loading') ? null : pintrestMessage" @transitionDone="pintrestMessage = null" class="loading"></message>
				<i class="fas fa-spinner fa-spin" v-if="pintrestMessage == 'loading'"></i>
			</div>

			<label><i class="fab fa-instagram"></i> Instagram</label>
			<input v-model="socialMediaPreferences.INSTAGRAM" type="text">
			<div class="message instagram">
				<message :message="(instagramMessage == 'loading') ? null : instagramMessage" @transitionDone="instagramMessage = null" class="loading"></message>
				<i class="fas fa-spinner fa-spin" v-if="instagramMessage == 'loading'"></i>
			</div>

			<label><i class="fab fa-youtube-square"></i> YouTube</label>
			<input v-model="socialMediaPreferences.YOUTUBE" type="text">
			<div class="message youtube">
				<message :message="(youtubeMessage == 'loading') ? null : youtubeMessage" @transitionDone="youtubeMessage = null" class="loading"></message>
				<i class="fas fa-spinner fa-spin" v-if="youtubeMessage == 'loading'"></i>
			</div>

			<label><i class="fa fa-fire"></i> BBB</label>
			<input v-model="socialMediaPreferences.BBB" type="text">
			<div class="message bbb">
				<message :message="(bbbMessage == 'loading') ? null : bbbMessage" @transitionDone="bbbMessage = null" class="loading"></message>
				<i class="fas fa-spinner fa-spin" v-if="bbbMessage == 'loading'"></i>
			</div>

			<label><i class="fa-brands fa-yelp"></i> Yelp</label>
			<input v-model="socialMediaPreferences.YELP" type="text">
			<div class="message yelp">
				<message :message="(yelpMessage == 'loading') ? null : yelpMessage" @transitionDone="yelpMessage = null" class="loading"></message>
				<i class="fas fa-spinner fa-spin" v-if="yelpMessage == 'loading'"></i>
			</div>

			<label><i class="fa-brands fa-tiktok"></i> TikTok</label>
			<input v-model="socialMediaPreferences.TIKTOK" type="text">
			<div class="message tiktok">
				<message :message="(tiktokMessage == 'loading') ? null : tiktokMessage" @transitionDone="tiktokMessage = null" class="loading"></message>
				<i class="fas fa-spinner fa-spin" v-if="tiktokMessage == 'loading'"></i>
			</div>

			<label><i class="fa-brands fa-threads"></i> Threads</label>
			<input v-model="socialMediaPreferences.THREADS" type="text">
			<div class="message threads">
				<message :message="(threadsMessage == 'loading') ? null : threadsMessage" @transitionDone="threadsMessage = null" class="loading"></message>
				<i class="fas fa-spinner fa-spin" v-if="threadsMessage == 'loading'"></i>
			</div>
			
			<label><i class="fa-solid fa-t">.</i> Truth Social</label>
			<input v-model="socialMediaPreferences.TRUTH" type="text">
			<div class="message truthsocial">
				<message :message="(truthMessage == 'loading') ? null : truthMessage" @transitionDone="truthMessage = null" class="loading"></message>
				<i class="fas fa-spinner fa-spin" v-if="truthMessage == 'loading'"></i>
			</div>

			<label><i class="fa-brands fa-square-bluesky"></i> Bluesky</label>
			<input v-model="socialMediaPreferences.BLUESKY" type="text">
			<div class="message bluesky">
				<message :message="(blueskyMessage == 'loading') ? null : blueskyMessage" @transitionDone="blueskyMessage = null" class="loading"></message>
				<i class="fas fa-spinner fa-spin" v-if="blueskyMessage == 'loading'"></i>
			</div>

		</div>
	</div>
    <loading v-else></loading>

	<help-popup :helpLink="{84:'Social Media'}" :tours="false"></help-popup>

</div>

</template>

<script>
import HelpPopup from '@/components/HelpPopup.vue'

export default {
	name: 'social-media',
	components: {
		'help-popup': HelpPopup
    },
	data() {
		return {
            loading: false,
			socialMediaPreferences: {
				'FACEBOOK': null,
				'TWITTER': null,
				'PINTREST': null,
				'INSTAGRAM': null,
				'YOUTUBE': null,
				'BBB': null,
				'TIKTOK': null,
				'YELP': null,
				'THREADS': null,
				'TRUTH': null,
				'BLUESKY': null
			},
			socialMediaPreferencesCopy: {
				'FACEBOOK': null,
				'TWITTER': null,
				'PINTREST': null,
				'INSTAGRAM': null,
				'YOUTUBE': null,
				'BBB': null,
				'TIKTOK': null,
				'YELP': null,
				'THREADS': null,
				'TRUTH': null,
				'BLUESKY': null
			},
			facebookMessage: null,
			twitterMessage: null,
			pintrestMessage: null,
			instagramMessage: null,
			youtubeMessage: null,
			bbbMessage: null,
			tiktokMessage: null,
			yelpMessage: null,
			threadsMessage: null,
			truthMessage: null,
			blueskyMessage: null
		}
	},
	created() {
		this.fetchData()
	},
	methods: {
		fetchData() {
            this.loading = true
            let preferenceCodes = ['FACEBOOK', 'TWITTER', 'PINTREST', 'INSTAGRAM', 'YOUTUBE', 'BBB', 'TIKTOK', 'YELP', 'THREADS', 'TRUTH', 'BLUESKY']
            this.apiCall({ destination: 'get_item_preference', data: { preference_code: preferenceCodes } }).then(obj => {
                this.loading = false
                for (let i = 0; i < preferenceCodes.length; i++) {
					this.socialMediaPreferences[preferenceCodes[i]] = this.$copy(obj[preferenceCodes[i]])
                    this.socialMediaPreferencesCopy[preferenceCodes[i]] = this.$copy(obj[preferenceCodes[i]])
                }
			}).catch(err => {
                this.loading = false
				console.log(err)
			})
		},
		save() {
			if (this.socialMediaPreferences['FACEBOOK'] != this.socialMediaPreferencesCopy['FACEBOOK']) {
				this.facebookMessage = 'loading'
				this.apiCall({ destination: 'save_item_preference', data: { preference_code: 'FACEBOOK', value: this.socialMediaPreferences['FACEBOOK'] } }).then(obj => {
					this.facebookMessage = obj.message
					this.socialMediaPreferencesCopy['FACEBOOK'] = this.$copy(this.socialMediaPreferences['FACEBOOK'])
				}).catch(err => {
					console.log(err)
				})
			}
			if (this.socialMediaPreferences['TWITTER'] != this.socialMediaPreferencesCopy['TWITTER']) {
				this.twitterMessage = 'loading'
				this.apiCall({ destination: 'save_item_preference', data: { preference_code: 'TWITTER', value: this.socialMediaPreferences['TWITTER'] } }).then(obj => {
					this.twitterMessage = obj.message
					this.socialMediaPreferencesCopy['TWITTER'] = this.$copy(this.socialMediaPreferences['TWITTER'])
				}).catch(err => {
					console.log(err)
				})
			}
			if (this.socialMediaPreferences['PINTREST'] != this.socialMediaPreferencesCopy['PINTREST']) {
				this.pintrestMessage = 'loading'
				this.apiCall({ destination: 'save_item_preference', data: { preference_code: 'PINTREST', value: this.socialMediaPreferences['PINTREST'] } }).then(obj => {
					this.pintrestMessage = obj.message
					this.socialMediaPreferencesCopy['PINTREST'] = this.$copy(this.socialMediaPreferences['PINTREST'])
				}).catch(err => {
					console.log(err)
				})
			}
			if (this.socialMediaPreferences['INSTAGRAM'] != this.socialMediaPreferencesCopy['INSTAGRAM']) {
				this.instagramMessage = 'loading'
				this.apiCall({ destination: 'save_item_preference', data: { preference_code: 'INSTAGRAM', value: this.socialMediaPreferences['INSTAGRAM'] } }).then(obj => {
					this.instagramMessage = obj.message
					this.socialMediaPreferencesCopy['INSTAGRAM'] = this.$copy(this.socialMediaPreferences['INSTAGRAM'])
				}).catch(err => {
					console.log(err)
				})
			}
			if (this.socialMediaPreferences['YOUTUBE'] != this.socialMediaPreferencesCopy['YOUTUBE']) {
				this.youtubeMessage = 'loading'
				this.apiCall({ destination: 'save_item_preference', data: { preference_code: 'YOUTUBE', value: this.socialMediaPreferences['YOUTUBE'] } }).then(obj => {
					this.youtubeMessage = obj.message
					this.socialMediaPreferencesCopy['YOUTUBE'] = this.$copy(this.socialMediaPreferences['YOUTUBE'])
				}).catch(err => {
					console.log(err)
				})
			}
			if (this.socialMediaPreferences['BBB'] != this.socialMediaPreferencesCopy['BBB']) {
				this.bbbMessage = 'loading'
				this.apiCall({ destination: 'save_item_preference', data: { preference_code: 'BBB', value: this.socialMediaPreferences['BBB'] } }).then(obj => {
					this.bbbMessage = obj.message
					this.socialMediaPreferencesCopy['BBB'] = this.$copy(this.socialMediaPreferences['BBB'])
				}).catch(err => {
					console.log(err)
				})
			}
			if (this.socialMediaPreferences['TIKTOK'] != this.socialMediaPreferencesCopy['TIKTOK']) {
				this.tiktokMessage = 'loading'
				this.apiCall({ destination: 'save_item_preference', data: { preference_code: 'TIKTOK', value: this.socialMediaPreferences['TIKTOK'] } }).then(obj => {
					this.tiktokMessage = obj.message
					this.socialMediaPreferencesCopy['TIKTOK'] = this.$copy(this.socialMediaPreferences['TIKTOK'])
				}).catch(err => {
					console.log(err)
				})
			}
			if (this.socialMediaPreferences['YELP'] != this.socialMediaPreferencesCopy['YELP']) {
				this.yelpMessage = 'loading'
				this.apiCall({ destination: 'save_item_preference', data: { preference_code: 'YELP', value: this.socialMediaPreferences['YELP'] } }).then(obj => {
					this.yelpMessage = obj.message
					this.socialMediaPreferencesCopy['YELP'] = this.$copy(this.socialMediaPreferences['YELP'])
				}).catch(err => {
					console.log(err)
				})
			}
			if (this.socialMediaPreferences['THREADS'] != this.socialMediaPreferencesCopy['THREADS']) {
				this.threadsMessage = 'loading'
				this.apiCall({ destination: 'save_item_preference', data: { preference_code: 'THREADS', value: this.socialMediaPreferences['THREADS'] } }).then(obj => {
					this.threadsMessage = obj.message
					this.socialMediaPreferencesCopy['THREADS'] = this.$copy(this.socialMediaPreferences['THREADS'])
				}).catch(err => {
					console.log(err)
				})
			}
			if (this.socialMediaPreferences['TRUTH'] != this.socialMediaPreferencesCopy['TRUTH']) {
				this.truthMessage = 'loading'
				this.apiCall({ destination: 'save_item_preference', data: { preference_code: 'TRUTH', value: this.socialMediaPreferences['TRUTH'] } }).then(obj => {
					this.truthMessage = obj.message
					this.socialMediaPreferencesCopy['TRUTH'] = this.$copy(this.socialMediaPreferences['TRUTH'])
				}).catch(err => {
					console.log(err)
				})
			}
			if (this.socialMediaPreferences['BLUESKY'] != this.socialMediaPreferencesCopy['BLUESKY']) {
				this.blueskyMessage = 'loading'
				this.apiCall({ destination: 'save_item_preference', data: { preference_code: 'BLUESKY', value: this.socialMediaPreferences['BLUESKY'] } }).then(obj => {
					this.blueskyMessage = obj.message
					this.socialMediaPreferencesCopy['BLUESKY'] = this.$copy(this.socialMediaPreferences['BLUESKY'])
				}).catch(err => {
					console.log(err)
				})
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.social-media-settings {
	display: grid;
	grid-gap: 0.5rem 1rem;
	grid-template-columns: 5rem 1fr 150px;
	align-items: center;
}
label {
    grid-column: 1 / 2;
	i {
		font-size: 3em;
    display: block;
	}
}
/*label { grid-column: span 2; }*/
input { grid-column: 2 / 3; }
.message { margin: 0; grid-column: 3 / 4; align-self: center; }
</style>
